import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { SwiperOptions } from 'swiper/types';

import { IRecipeCard, IRecipeCardWithLayout, SdRecipeCardComponent } from '@seb/web-design-system/recipe-card';
import { ISliderInfo, SdThemeComponent, SizesEnum } from '@seb/web-design-system/core';
import { SdSliderComponent } from '@seb/web-design-system/sliders';

@Component({
  selector: 'sd-recipe-slider',
  templateUrl: './recipe-slider.component.html',
  styleUrls: ['./recipe-slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdSliderComponent,
    SdRecipeCardComponent
  ]
})
export class SdRecipeSliderComponent extends SdThemeComponent {
  @Input()
  recipeCardsSliderConfig: SwiperOptions = {
    pagination: {
      dynamicBullets: false,
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        spaceBetween: 12,
        slidesPerView: 'auto'
      },
      768: {
        spaceBetween: 20
      },
      1280: {
        spaceBetween: 28
      }
    }
  };

  @Input()
  size: SizesEnum = SizesEnum.s;

  @Input()
  isLoading = false;

  @Input()
  context = 'Recipe card slider';

  @Input()
  recipeCards: IRecipeCardWithLayout[];

  @Input()
  twicPicsAutoSize = true;

  @Output()
  clicked = new EventEmitter<IRecipeCard>();

  @Output()
  itemsRule = new EventEmitter<ISliderInfo>();

  onSlideChange(event: ISliderInfo): void {
    this.itemsRule.emit(event);
  }

  onClick(recipe: IRecipeCard): void {
    this.clicked.emit(recipe);
  }
}
